var map = {
	"./role-1/4.png": "tyeO",
	"./role-2/4.png": "YNyT",
	"./role-3/4.png": "TUek",
	"./role-4/4.png": "4l1w"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "TBPQ";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4 ^\.\/role\-.*\/4\.png$
// module id = TBPQ
// module chunks = 0